var _style, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvadaG(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "500px",
    height: "500px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_2_);}\r\n\t.st1{fill:#65BC7B;}\r\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 500,
    height: 500
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1.1,485.2c-3.5,6.9,1.8,14.7,9.6,14.7c221.6,0.4,387-213.9,265.6-458L258.2,5.7c-3.8-7.5-14.4-7.5-18.2,0 L1.1,485.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M387.2,264.6c-3.8-7.5-14.5-7.5-18.2,0l-55,107.3c-29.6,59.1,7.6,128.2,78.9,128.2h96.9 c7.5,0,12.5-7.9,9.1-14.7L387.2,264.6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvadaG);
export default __webpack_public_path__ + "static/media/avada-g.97512b0db6a0f11c9b8abc0027f587d4.svg";
export { ForwardRef as ReactComponent };